import { Box, Text } from '@elkaso-app/web-design';

interface DocumentViewerProps {
  s3Url: string;
  mimeType: string;
  originalFileName: string;
}

export const DocumentViewer = ({ s3Url, mimeType, originalFileName }: DocumentViewerProps) => {
  const isPdf = mimeType === 'application/pdf';
  const isImage = mimeType?.startsWith('image/');

  return (
    <Box>
      <Text fontSize='sm' color='gray.500' mb='sm' noOfLines={1}>
        {originalFileName}
      </Text>
      <Box borderRadius='md' overflow='hidden' border='1px' borderColor='gray.200'>
        {isPdf ? (
          <iframe src={s3Url} width='100%' height='600px' title={originalFileName} style={{ border: 'none' }} />
        ) : isImage ? (
          <img src={s3Url} alt={originalFileName} style={{ width: '100%', height: 'auto', display: 'block' }} />
        ) : (
          <Box p='lg' textAlign='center'>
            <Text color='gray.500'>Preview not available for this file type.</Text>
            <Text
              as='a'
              href={s3Url}
              target='_blank'
              rel='noopener noreferrer'
              color='blue.500'
              textDecoration='underline'>
              Open file in new tab
            </Text>
          </Box>
        )}
      </Box>
    </Box>
  );
};
